import React from 'react';
export function FinalCTA() {
  return <section className="bg-black py-5 md:py-16 px-4 text-center border-b border-gray-800" data-id="element-56">
      <div className="max-w-4xl mx-auto" data-id="element-57">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-2 md:mb-4" data-id="element-58">
          ¿Listo para empezar a construir y generar ingresos reales?
        </h2>
        <p className="text-xl md:text-2xl text-gray-300 mb-3 md:mb-6" data-id="element-59">
          Sumate a miles de personas que ya transformaron sus manos en su mejor
          herramienta de trabajo.
        </p>
      </div>
    </section>;
}